import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 394 116"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M0 0v116h34.627V82.099h95.394v-32.39H34.627V32.39h129.458V0zM281.608 0l-15.287 24.593L251.041 0h-40.299l20.135 32.39h-40.284L138.641 116h40.291l51.952-83.602 15.287 24.6L209.499 116h40.299l16.523-26.59 16.53 26.59h40.291L286.47 56.998l15.28-24.586L353.709 116h40.292L321.899 0z"
    }, null, -1)
  ])))
}
export default { render: render }